import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import clone from 'lodash/clone';
import { observer } from 'mobx-react-lite';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useStore } from 'hooks';
import { checkSelect, useCloseMenuOnScroll } from '../../../../utils';
import { Coords, DisabledHouse } from '../../../../types';
import { TooltipInner } from 'components';
import { Button } from 'components/ui';
import {
  CheckIcon,
  EmptyIcon,
  Footer,
  MenuWrapper,
  OptionItem,
  OptionWrapper,
  ScrollWrapper,
  Text,
} from './selected-item.styled';

interface IProps {
  item: any;
  coords: Coords;
  applyItems: () => void;
  closePortal: () => void;
  disabledHouses?: DisabledHouse[];
}

type HouseWithStatus = {
  house: any;
  disabledInfo?: DisabledHouse;
  isSelected: boolean;
};

export const SelectedItemMenu = observer(
  ({ item, coords, applyItems, closePortal, disabledHouses }: IProps) => {
    const { fias } = useStore();
    const menuRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
    useCloseMenuOnScroll(menuRef, () => closePortal());

    useLayoutEffect(() => {
      if (menuRef.current) {
        setHeight(menuRef.current.clientHeight);
      }
    }, []);

    //TODO: типизировать
    const handleChangeSelectedHouse = (currentItem: any) => {
      if (checkCurrentHouseDisabled(currentItem)) {
        return; // блокируем выбор
      }

      let params = clone(fias.currentSelectedHouses);

      // Нижний уровень должен знать своего родителя
      if (!currentItem.parent) {
        currentItem.parent = item.AOGUID;
      }

      if (checkSelect(currentItem, params)) {
        params = params.filter((item) => item._id !== currentItem._id);
      } else {
        params.push(currentItem);
      }

      fias.setCurrentSelectedHouses(params);
    };

    //TODO: типизировать
    const checkCurrentHouseDisabled = (currentItem: any) => {
      return currentItem?._id
        ? disabledHouses?.find((house) => house.id === currentItem._id)
        : undefined;
    };

    // Подготовка списка домов заранее с признаком disabledInfo
    const housesWithStatus: HouseWithStatus[] = useMemo(() => {
      return item.houses.map((house: any) => {
        const disabledInfo = checkCurrentHouseDisabled(house);
        const isSelected = checkSelect(house, fias.currentSelectedHouses);

        return { house, disabledInfo, isSelected };
      });
    }, [item.houses, fias.currentSelectedHouses, disabledHouses]);

    return (
      <MenuWrapper coords={coords} ref={menuRef} height={height}>
        <ScrollWrapper>
          {housesWithStatus.map(
            ({ house, disabledInfo, isSelected }, index) => (
              <OptionItem key={index}>
                <OptionWrapper
                  onClick={() => handleChangeSelectedHouse(house)}
                  $isDisabled={!!disabledInfo}
                  data-tooltip-id={house?._id}
                  data-tooltip-variant="info"
                >
                  <Text $isDisabled={!!disabledInfo}>
                    {house.short_address}
                  </Text>
                  {isSelected ? <CheckIcon /> : <EmptyIcon />}
                </OptionWrapper>

                {!!disabledInfo && (
                  <ReactTooltip id={house?._id} variant="info">
                    <TooltipInner>{disabledInfo.reason}</TooltipInner>
                  </ReactTooltip>
                )}
              </OptionItem>
            )
          )}
        </ScrollWrapper>

        <Footer>
          {/*TODO: Раньше тут была кнопка высотой 26px. Новая кнопка бывает 24 или 32, выбрал 24px*/}
          <Button size={'xs'} variant={'outline'} onClick={applyItems}>
            Применить
          </Button>
        </Footer>
      </MenuWrapper>
    );
  }
);
